import { Card, CardContent, Grid, Stack, Typography } from '@mui/material';
import React from 'react';

type SettingsControlPanelProps = {
  controlGroupTitle: string;
  controlGroupDescription?: string | React.ReactNode;
  children: React.ReactNode;
};

export default function SettingsControlPanel({
  controlGroupTitle,
  controlGroupDescription,
  children,
}: SettingsControlPanelProps) {
  return (
    <Grid container>
      <Stack spacing={1} sx={{ width: '100%' }}>
        <Card>
          <CardContent>
            <Typography variant="h5" fontWeight="bold" mb={2}>
              {controlGroupTitle}
            </Typography>
            {controlGroupDescription && (
              <div>
                {typeof controlGroupDescription === 'string' ? (
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    mt={0}
                    mb={5}>
                    {controlGroupDescription}
                  </Typography>
                ) : (
                  <>{controlGroupDescription}</>
                )}
              </div>
            )}
            {React.Children.map(children, (child, index) => (
              <div key={index}>{child}</div>
            ))}
          </CardContent>
        </Card>
      </Stack>
    </Grid>
  );
}
